const DOCUMENT = 'INTERVIEWS_';

const actions = {
  ASSIGN_APPLICANT: DOCUMENT + 'ASSIGN_APPLICANT',
  CHANGE_DATA: DOCUMENT + 'CHANGE_DATA',
  CHECK_IN: DOCUMENT + 'CHECK_IN',
  CHECK_IN_SUCCESS: DOCUMENT + 'CHECK_IN_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  LOAD: DOCUMENT + 'LOAD',
  LOAD_APPLICANTS_LIST: DOCUMENT + 'LOAD_APPLICANTS_LIST',
  LOAD_APPLICANTS_LIST_SUCCESS: DOCUMENT + 'LOAD_APPLICANTS_LIST_SUCCESS',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  NO_SHOW_ACTION: DOCUMENT + 'NO_SHOW_ACTION',
  REMOVE_CHECK_IN: DOCUMENT + 'REMOVE_CHECK_IN',
  REMOVE_CHECK_IN_SUCCESS: DOCUMENT + 'REMOVE_CHECK_IN_SUCCESS',
  UNDO_NO_SHOW_ACTION: DOCUMENT + 'UNDO_NO_SHOW_ACTION',
  START_VIDEO_INTERVIEW: DOCUMENT + 'START_VIDEO_INTERVIEW',
  PROCESS_ACTION: DOCUMENT + 'PROCESS_ACTION',

  assignApplicant: data => ({ type: actions.ASSIGN_APPLICANT, payload: data }),
  changeData: data => ({ type: actions.CHANGE_DATA, payload: data }),
  checkIn: data => ({ type: actions.CHECK_IN, payload: data }),
  checkInSuccess: data => ({ type: actions.CHECK_IN_SUCCESS, payload: data }),
  clearStore: () => ({ type: actions.CLEAR_STORE }),
  loadApplicantsList: data => ({ type: actions.LOAD_APPLICANTS_LIST, payload: data }),
  loadApplicantsListSuccess: data => ({ type: actions.LOAD_APPLICANTS_LIST_SUCCESS, payload: data }),
  loadData: data => ({ type: actions.LOAD, payload: data }),
  loadDataSuccess: data => ({ type: actions.LOAD_SUCCESS, payload: data }),
  noShowAction: data => ({ type: actions.NO_SHOW_ACTION, payload: data }),
  removeCheckIn: data => ({ type: actions.REMOVE_CHECK_IN, payload: data }),
  removeCheckInSuccess: data => ({ type: actions.REMOVE_CHECK_IN_SUCCESS, payload: data }),
  undoNoShowAction: data => ({ type: actions.UNDO_NO_SHOW_ACTION, payload: data }),
  startVideoInterview: data => ({ type: actions.START_VIDEO_INTERVIEW, payload: data }),
  onProcessAction: data => ({ type: actions.PROCESS_ACTION, payload: data }),
};

export default actions;
